/* eslint-disable no-nested-ternary */
import { ReactElement } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { nanoid } from 'nanoid';
import { Empty, Loader } from '@rootCommon/components';
import { StringIndexed } from '@rootCommon/types/common';

type Props<T> = {
  header?: ReactElement;
  isLoading?: boolean;
  items?: Array<T>;
  keyField?: keyof T;
  loadMore?: () => void;
  renderItem: (item: T) => ReactElement;
};

function DataTable<T extends StringIndexed>({
  items,
  renderItem,
  loadMore,
  keyField,
  header,
  isLoading,
}: Props<T>): JSX.Element {
  const infiniteScroll = (list: ReactElement | ReactElement[]) => (loadMore ? (
    <InfiniteScroll initialLoad={false} pageStart={0} loadMore={loadMore} hasMore useWindow={false}>
      {list}
    </InfiniteScroll>
  ) : (
    list
  ));

  const dataListItem = (item: T): JSX.Element => <div className="table__row">{renderItem(item)}</div>;

  const itemsList = (items: T[]): JSX.Element[] => items
    .map((item) => <div key={keyField ? item[keyField] : nanoid()}>{dataListItem(item)}</div>);

  return (
    <div className="data-list-container">
      {isLoading ? (
        <Loader />
      ) : items?.length ? (
        <div className="table">
          {header && (
            <div className="table__top">
              <div className="table__top-wrap">{header}</div>
            </div>
          )}
          <div className="table__body">{infiniteScroll(itemsList(items))}</div>
        </div>
      ) : (
        <Empty />
      )}
    </div>
  );
}

export default DataTable;
